var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPushNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00977 3C2.91077 3 2.00977 3.9 2.00977 5L2 16.998C2 18.103 2.896 19 4 19H5.5C5.776 19 6 19.224 6 19.5V21.5859C6 22.4769 7.07703 22.923 7.70703 22.293L10.209 19.791C10.076 19.215 10 18.617 10 18C10 13.582 13.582 10 18 10C19.459 10 20.822 10.3961 22 11.0781V5C22 3.9 21.1 3 20 3H4.00977ZM18 12C14.6981 12 12 14.6981 12 18C12 21.3019 14.6981 24 18 24C21.3019 24 24 21.3019 24 18C24 14.6981 21.3019 12 18 12ZM18 14C20.221 14 22 15.779 22 18C22 20.221 20.221 22 18 22C15.779 22 14 20.221 14 18C14 15.779 15.779 14 18 14ZM18 16C17.448 16 17 16.448 17 17V19C17 19.552 17.448 20 18 20C18.552 20 19 19.552 19 19V17C19 16.448 18.552 16 18 16Z",
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPushNotification);
export default __webpack_public_path__ + "static/media/ic_push_notification.f6e2e66b530a580075b0f60cc0e96c32.svg";
export { ForwardRef as ReactComponent };